<template>
    <div class="auth-template" v-show="can">
        <slot></slot>
    </div>
</template>

<script>
import Authorization from '@/providers/Authorization'

export default {
    name: 'AuthTemplate',
    props: {
        model: String,
        action: String,
        arg: Number,
    },
    data () {
        return {
            can: false
        }
    },
    created () {
        Authorization.can({ model: this.model, action: this.action, arg: this.arg }).then((can) => {
            this.can = can
        })

    }
}
</script>

<style scoped>

</style>